import { PlanModelInfo, planTypes } from '@/common/constants';
import { planUnitMap } from '@/common/product-unit';
import { defaultMapper } from '@/common/service/default-mapper';

const whiteboardCategory = {
  whiteboard: { typeNameKey: 'billing.zoom_whiteboard.title', planNameKey: 'billing.zoom_whiteboard.title' },
  whiteboard_plus: { typeNameKey: 'billing.zoom_whiteboard.title', planNameKey: 'billing.zoom_whiteboard_plus.title' },
};

export const WHITEBOARD_PLUS_PLAN_MAPS = {
  MONTHLY: 'zwb_plus_monthly',
  ANNUAL: 'zwb_plus_yearly'
}

export default (planMapJSON = {}) => {
  const cycleDepList = []

  return Object.keys(whiteboardCategory).reduce((pre, key) => {
    return [
      ...defaultMapper(planMapJSON[key], planTypes.ZOOM_WHITEBOARD).map(item => ({
        ...item,
        ...whiteboardCategory[key],
        billingCycleDependBasePlanTypeList: cycleDepList,
        standAlone: true,
        unit: planUnitMap.license,
        planModel: PlanModelInfo.license,
      })),
      ...pre,
    ];
  }, []);
}
